import { Vue } from 'vue-property-decorator';
import EventBus from '@/helpers/EventBus';
export function openModal(options) {
    Vue.prototype.$modals.$emit('new:modal', options);
}
export function registerModalEventListeners() {
    // dismisses a modal by name
    EventBus.$on('tix:modal:dismiss', (modalName) => {
        const modals = Vue.prototype.$modals;
        modals.close({
            $index(data, modals) {
                return modals.findIndex((modal) => modal.name === modalName);
            },
        });
    });
}
export function getNormalizedModalOptions(options) {
    const defaults = {
        name: '',
        size: 'lg',
        closeable: true,
        onClose() { },
        desktop: 'modal',
        mobile: 'drawer',
    };
    return { ...defaults, ...options };
}
